import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class CampaignPreview extends BaseModel {
  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  customer_id;

  /**
   * @var {string}
   */
  service_id;

  /**
   * @var {string}
   */
  grid_id;

  /**
   * @var {string}
   */
  dataview;

  constructor(model = {}) {
    super(model);
    this.name = model.name;
    this.customer_id = model.customer_id;
    this.service_id = model.service_id;
    this.grid_id = model.grid_id;
    this.dataview = model.dataview;
  }
}
